import { TemplateConfig } from '../types';

export const ambiguousSpreadConfig: TemplateConfig = {
  id: 'ambiguous-spread',
  name: '暧昧牌阵',
  description: '分析暧昧关系的发展可能性',
  cardCount: 5,
  
  fieldDefaults: {
    title: '暧昧牌阵',
    customerQuestion: '**从多个角度分析我和对方在一起的可能性，对方的想法，如何增进感情**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌',
      '请输入第 2 行第 1 张牌'
    ],
    cardInfos: [
      '对方的暧昧对象是否只有我',
      '我和对方的感情发展',
      '对方对我的真实想法',
      '我和对方如何增进感情',
      '近期是否适合告白'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💖'
  }
};